// main.js
import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import NaiveUI from 'naive-ui'

// 移除有问题的样式导入
// import 'naive-ui/dist/index.css'

const app = createApp(App)
app.use(createPinia())
app.use(NaiveUI)
app.mount('#app')
